/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown> }} No_Transcript_For_LanguageInputs */



/**
* | output |
* | --- |
* | "No transcript found for the selected language: {language}." |
*
* @param {No_Transcript_For_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_transcript_for_language = /** @type {((inputs: No_Transcript_For_LanguageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Transcript_For_LanguageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Aucune transcription trouvée pour la langue sélectionnée : ${i?.language}.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Für die ausgewählte Sprache wurde kein Transkript gefunden: ${i?.language}.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Nessuna trascrizione trovata per la lingua selezionata: ${i?.language}.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Транскрипт для выбранного языка не найден: ${i?.language}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se encontró ninguna transcripción para el idioma seleccionado: ${i?.language}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`未找到所选语言的转录文本：${i?.language}。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`選択された言語のトランスクリプトが見つかりません: ${i?.language}。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`चुनी गई भाषा के लिए कोई प्रतिलेख नहीं मिला: ${i?.language}.`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi encontrada nenhuma transcrição para o idioma selecionado: ${i?.language}.`)
	return /** @type {LocalizedString} */ (`No transcript found for the selected language: ${i?.language}.`)
});